//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.AppendedTextBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Annotations/Annotations.OrdinateBaselineBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActiveHorizontalMargin",1,"Annotations.OrdinateMargin",0],[0,"ActiveVerticalMargin",1,"Annotations.OrdinateMargin",0],[0,"AllowDuplicates",1,0],[1,"AppendedText",0,"Annotations.AppendedTextBuilder",0],[1,"AutoAssociativities",0,"SelectDisplayableObjectList",0],[1,"Baseline",0,"Annotations.OrdinateBaselineBuilder",0],[0,"HorizontalInferredMarginLocation",1,0],[1,"Inherit",0,"SelectDisplayableObject",0],[1,"OrdinateOrigin",0,"SelectDisplayableObject",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[0,"RepositionExisting",1,0],[1,"SecondAssociativities",0,"SelectDisplayableObject",0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"Type",1,0],[0,"VerticalInferredMarginLocation",1,0]],[],[]];
SPLM.Annotations.BaseOrdinateDimensionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BaseOrdinateDimensionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BaseOrdinateDimensionBuilder.Types = Object.freeze({
    "SingleDimension" : "SingleDimension", "MultipleDimension" : "MultipleDimension"});

export default SPLM;